export default {
      id: "ic-misc-plus-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-plus-usage",
      toString: function () {
        return this.url;
      }
    }